export default __webpack_public_path__ + "static/media/chevron-left.c80cdd8e.svg";